import { useRouteMatch } from 'react-router-dom';

function useRouteMatchParam(param: string) {
  const value = useRouteMatch<{ [key: string]: string }>().params[param];

  return value;
}

export default useRouteMatchParam;
